@custom-media --mobile (max-width: 768px);

.questionRow {
  margin: 0;
  padding: 0.5rem 0 0.5rem 0.5rem;

  &:nth-child(odd) {
    background-color: var(--silver);
  }

  &:last-of-type:not(:only-of-type) {
    margin-bottom: 2.5rem;
    padding-bottom: 0.5rem;
  }

  @media (--mobile) {
    flex-direction: column;
  }
}

.option {
  cursor: pointer;

  @media (--mobile) {
    display: flex;
    padding: 0;
    margin: 0;
  }

  & input {
    cursor: pointer;
  }
}

.optionInput {
  @media (--mobile) {
    display: flex;
    align-items: flex-start;
    padding: 0.5rem 1rem 0 0;
  }

}

.optionLabel {
  display: none;
  font-weight: 400;
  text-align: left;

  @media (--mobile) {
    display: flex;
    font-size: 1rem;
  }
}
